// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2mCHG","blue":"Button_blue__3zqrl","gray":"Button_gray__FKnjk","white":"Button_white__3sitg"};